import { Stack, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

import { CourtHearingsFilterBar } from "./components/filter/CourtHearingsFilterBar";
import { CourtHearingsReport } from "./components/report/CourtHearingsReport";
import { useCourtHearings } from "./hooks/useCourtHearings";

export function CourtHearings() {
  const { t } = useTranslation();
  const { formik, grouping, setGrouping, rows, isLoading, isError, hasSearchParams } = useCourtHearings();

  return (
    <Stack spacing={2} sx={{ height: "100%" }} pb={3}>
      <Typography variant="h1">{t("courtHearings.title")}</Typography>
      <CourtHearingsFilterBar formik={formik} grouping={grouping} onGroupingChange={setGrouping} />
      <Stack sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <CourtHearingsReport
          rows={rows}
          grouping={grouping}
          isLoading={isLoading}
          isError={isError}
          hasSearchParams={hasSearchParams}
        />
      </Stack>
    </Stack>
  );
}
